import { Box, Collapse, IconButton } from "@mui/material"
import { DeleteOutlined, KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { AddedProduct } from "../../types"

import { ProductCard } from "./ProductCard"

import { AerosCheckbox } from "@/components/UiKit"

interface AddedProductCardProps {
  addedProduct: AddedProduct
  onRemove: () => void
  onRequestQuoteChange: (checked: boolean) => void
  onExpandToggle: () => void
}

export const AddedProductCard: FC<AddedProductCardProps> = ({
  addedProduct,
  onRemove,
  onRequestQuoteChange,
  onExpandToggle,
}) => {
  const { product, requestQuote, isExpanded } = addedProduct

  return (
    <Box className='overflow-hidden rounded border border-gray-300'>
      <Box className='p-3'>
        <Box className='flex items-start gap-2 rounded border border-gray-300 p-4'>
          <ProductCard product={product} />
          <IconButton
            size='small'
            onClick={onRemove}
            className='shrink-0'
            aria-label='Remove product'
            data-testid={`sales.added-product-card.remove-button-${product.productId}`}
          >
            <DeleteOutlined />
          </IconButton>
        </Box>
      </Box>

      <Box className='flex flex-col gap-1 px-4 pb-3'>
        <AerosCheckbox
          checked={requestQuote}
          onChange={onRequestQuoteChange}
          size='small'
          label='Request Quote'
          data-testid={`sales.added-product-card.request-quote-checkbox-${product.productId}`}
        />
        <AerosCheckbox disabled size='small' label='Request Sample' />
        <AerosCheckbox disabled size='small' label='Request Documents' />
      </Box>

      <Box className='flex justify-center pb-2'>
        <IconButton
          onClick={onExpandToggle}
          size='small'
          aria-label={isExpanded ? "Collapse details" : "Expand details"}
          className='text-gray-500'
          data-testid={`sales.added-product-card.expand-button-${product.productId}`}
        >
          {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>{/* Expandable content — future scope */}</Collapse>
    </Box>
  )
}
